import type { ResolvedProofreadingBatchChecks } from "@/lib/api/proofreadingAi";
import {
  AI_PROOFREADING_CHECK_IDS,
  AI_PROOFREADING_RESULT_KEYS,
} from "@/constants/proofreadingAiChecks";

/** GA の `proofreading_method`。画面の校正項目 1 種に対応する。 */
export type ProofreadingMethod =
  | "error_check"
  | "story_check"
  | "expression_check"
  | "foreshadow_check";

/**
 * 投入するチェックから `proofreading_method` を決める。
 * 未選択なら undefined。複数 ON でも画面と同じく先頭の 1 種だけを返す。
 */
export function toProofreadingMethod(
  checks: ResolvedProofreadingBatchChecks,
): ProofreadingMethod | undefined {
  const selected = AI_PROOFREADING_CHECK_IDS.find((checkId) => checks[checkId] === true);
  if (!selected) return undefined;
  const method = AI_PROOFREADING_RESULT_KEYS[selected];
  if (
    method === "error_check"
    || method === "story_check"
    || method === "expression_check"
    || method === "foreshadow_check"
  ) {
    return method;
  }
  return undefined;
}
